import React from 'react';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { CustomizedSwitches, ISwitchProps } from '../Switch/Switch';
import { ToolTip } from '../Tip/ToolTip';
import { isEmptyValue } from '../../utils/lodash';
import { StyledBadge } from '../StyledBadge';
import { FormLabel } from '@mui/material';

export interface ICustomHeaderWithStatus {
    headerTitle: string;
    field: string;
    state: Record<string, any>;
    themeStyle: ColorScheme;
    headerToolTip?: string;
    isRequired?: boolean;
    switchType?: boolean;
    switchProps?: ISwitchProps;
    style?: React.CSSProperties;
    /** Hide red/green validation dot (e.g. brand dashboard modals). */
    hideStatusIndicator?: boolean;
    /** Bold uppercase label styling (Midnight editorial forms) */
    editorial?: boolean;
}

export const CustomHeaderWithStatus = ({
    headerTitle,
    headerToolTip,
    isRequired,
    themeStyle,
    field,
    state,
    switchType,
    switchProps,
    style,
    hideStatusIndicator = false,
    editorial,
}: ICustomHeaderWithStatus): JSX.Element => {
    const baseLabelStyle: React.CSSProperties = editorial
        ? {
              textAlign: 'left',
              fontSize: 12,
              fontStyle: 'normal',
              fontWeight: 700,
              color: '#adaaaa',
              fontFamily: FONT_ENUM.MAIN_BOLD,
              display: 'flex',
              alignItems: 'center',
              border: 'none',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
          }
        : {
              textAlign: 'left',
              fontSize: 14,
              fontStyle: 'normal',
              fontWeight: '400',
              color: theme[themeStyle].form_label,
              fontFamily: FONT_ENUM.MAIN_BOLD,
              display: 'flex',
              alignItems: 'center',
              border: 'none',
          };
    const coreSegment = (
        <>
            {headerTitle} {headerToolTip && <ToolTip text={headerToolTip} />}{' '}
            {!hideStatusIndicator && (
                <StyledBadge
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    overlap="circular"
                    invisible={!isRequired}
                    variant="dot"
                    sx={{
                        height: '20px',
                        width: '20px',
                    }}
                    errorState={isEmptyValue(state[field])}
                />
            )}
        </>
    );
    if (switchType) {
        return (
            <FormLabel
                style={{
                    ...baseLabelStyle,
                    marginBottom: '8px',
                    ...style,
                }}
                component={'span'}>
                <CustomizedSwitches
                    {...switchProps}
                    style={{
                        textAlign: 'left',
                        fontSize: editorial ? 12 : 14,
                        fontStyle: 'normal',
                        fontWeight: editorial ? 700 : '400',
                        color: editorial ? '#adaaaa' : theme[themeStyle].form_label,
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        display: 'flex',
                        alignItems: 'center',
                        border: 'none',
                    }}
                />
                {coreSegment}
            </FormLabel>
        );
    }
    return (
        <FormLabel
            style={{
                ...baseLabelStyle,
                ...style,
            }}
            component={'span'}>
            {coreSegment}
        </FormLabel>
    );
};
